import { initTeacherFilter } from "./filter-module"

import "../../../../components/forms/main-page/form"

import "../../../../components/headers/main/header"
import "../../../../components/prepare/prepare.ts"
import "./marque"
import "./counter"
import { initSwipers } from "./swipers-init"
import "./docs-tooltip"
import "./faq"
import "./result"
import "../../../../components/modals/main/callback-modal"
import "/dev/core/utm/utm"
import CoursesModal from "../../../../dev/core/courses-modal"
// Импортируем модуль модалок каталога (entry point)
import "/dev/core/catalog-modals/catalog-modals"
import "../../../../dev/core/metrika/actions"
import "../../../../components/teachersV2/team"

document.addEventListener("DOMContentLoaded", () => {
  initTeacherFilter()
  initSwipers()
  // Открытие модалки курсов по преподавателю
  document.addEventListener("click", (e) => {
    const target = (e.target as HTMLElement).closest(
      ".buyModal__open[data-teacher-slug]"
    )
    if (!target) return

    const teacherSlug = target.getAttribute("data-teacher-slug")
    if (!teacherSlug) return

    // Получаем grade из data-grade или data-class
    const grade =
      target.getAttribute("data-grade") || target.getAttribute("data-class")

    new CoursesModal(teacherSlug, grade || undefined).init()
  })
})

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".customPlayer").forEach(function (e) {
    const t = e.querySelector("video"),
      s = e.querySelector(".playButton"),
      n = e.querySelector(".stopButton"),
      a = e.querySelector(".customPlayer__controls"),
      o = e.querySelector(".progressBar__foreground")
    let i
    function r() {
      t.paused
        ? (s.classList.add("visible"), n.classList.remove("visible"))
        : s.classList.remove("visible")
    }
    ;(!(function () {
      const e = o.r.baseVal.value,
        t = 2 * Math.PI * e
      ;((o.style.strokeDasharray = `${t} ${t}`), (o.style.strokeDashoffset = 0))
    })(),
      r(),
      e.addEventListener("click", function (e) {
        e.target.classList.contains("stopButton")
          ? t.pause()
          : e.target.classList.contains("playButton") || t.paused
            ? t.play()
            : t.pause()
      }),
      t.addEventListener("play", r),
      t.addEventListener("pause", r),
      t.addEventListener("ended", r),
      t.addEventListener("timeupdate", function () {
        const e = o.r.baseVal.value,
          s = 2 * Math.PI * e,
          n = s - (t.currentTime / t.duration) * s
        o.style.strokeDashoffset = n
      }),
      e.addEventListener("mouseenter", function () {
        t.paused || (n.classList.add("visible"), clearTimeout(i))
      }),
      e.addEventListener("mouseleave", function () {
        t.paused ||
          (i = setTimeout(function () {
            n.classList.remove("visible")
          }, 1e3))
      }),
      a.addEventListener("click", function (e) {
        e.stopPropagation()
      }),
      t.addEventListener("click", function (e) {
        ;(e.stopPropagation(), t.paused ? t.play() : t.pause())
      }),
      e.addEventListener("keydown", function (e) {
        ;("Enter" !== e.key && " " !== e.key) ||
          (e.preventDefault(), t.paused ? t.play() : t.pause())
      }))
  })
})
